import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Loader from "../loader";
import { setValidated } from "../../store/reducer/accountReducer";
import { useDispatch } from "react-redux";
const BvnValidation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [bvnResponseMessage, setBvnResponseMessage] = useState("");
  const [otpResponseMessage, setOtpResponseMessage] = useState("");
  const [bvn, setBvn] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setBvnResponseMessage("");
    }, 5000);

    return () => clearTimeout(timer);
  }, [bvnResponseMessage]);

  const handleBvnSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimer(60);
    try {
      setIsLoading(true);

      const response = await axios.post(
        `https://digitalbanking.suntrustng.com:8443/bvn_validation_new/api/BVNValidations/verifyBVN`,
        { bvn: bvn, isAccountOpening: true }
      );

      // console.log(response.data);

      // Store the access token from BVN validation response
      const accessToken = response.data.access_token;
      sessionStorage.setItem("bvnAuthToken", accessToken);

      setBvn("");
      sessionStorage.setItem("bvn", JSON.stringify(bvn));
      setIsLoading(false);
      setShowOtpForm(true);
    } catch (error) {
      setIsLoading(false);
      if (error?.message === "Network Error") {
        setBvnResponseMessage("Opps something went wrong !!, Please try again");
      } else {
        setBvnResponseMessage(error?.message);
      }
    }
  };

const handleOtpSubmit = async (e) => {
  e.preventDefault();
  const otp = e.target.elements.otp.value; // get otp entered by user

  setIsOtpLoading(true); // Start loading

  const bvn = JSON.parse(sessionStorage.getItem("bvn"));
  const authToken = sessionStorage.getItem("bvnAuthToken");
  
  try {
    const res = await axios.post(
      `https://digitalbanking.suntrustng.com:8443/bvn_validation_new/api/BVNValidations/VerifyOtp`,
      {
        bvn: bvn,
        otp: otp
      },
      {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      }
    );

    // console.log(res.data);
    
    // Check if OTP is valid based on the response structure
    if (res.data.isOtpValid === true) {
      navigate("/openKiddiesAccount/create-account");
      dispatch(setValidated());
      sessionStorage.removeItem("bvn");
      // sessionStorage.removeItem("bvnAuthToken");
    } else {
      setOtpResponseMessage("Invalid OTP or OTP has expired");
    }
  } catch (error) {
    if (error.response?.data?.responseMessage) {
      setOtpResponseMessage(error.response.data.responseMessage);
    } else if (error.response?.data) {
      // Handle case where OTP is invalid but request was successful
      const responseData = error.response.data;
      if (responseData.isOtpValid === false) {
        setOtpResponseMessage("Invalid OTP. Please try again.");
      } else {
        setOtpResponseMessage(responseData.responseMessage || "OTP verification failed");
      }
    } else {
      setOtpResponseMessage("OTP verification failed. Please try again.");
    }
  } finally {
    setIsOtpLoading(false); // Stop loading regardless of success/error
  }
};

  const reSendOtp = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimer(60);
    try {
      setIsLoading(true);
      const bvn = JSON.parse(sessionStorage.getItem("bvn"));
      const response = await axios.post(
        `https://digitalbanking.suntrustng.com:8443/bvn_validation_new/api/BVNValidations/verifyBVN`,
        { bvn: bvn, isAccountOpening: true }
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main_content" id="main-content">
      <div className="page">
        <div className="flex-column">
          <div className="kiddies_hero"></div>

          <div className="kiddies_hero-tablet"></div>

          <div className="kiddies_hero-mobile"></div>

          <div className="col-lg-12  m-b-50 ">
            <div className="tab-content" id="myTabContent">
              <div
                className="fade show active"
                id="account_spec"
                role="tabpanel"
                aria-labelledby="account_spec-tab"
              >
                {/* <!-- BVN Verification --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-user m-r-5"></i> BVN Verification
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the BVN of the Guardian of the
                        child is entered and verified. Please, provide the
                        correct details.
                      </div>
                    </div>
                    <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                      {!showOtpForm && (
                        <form onSubmit={handleBvnSubmit}>
                          <div className="row m-b-30">
                            <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                              <label>Bank Verification Number (BVN)</label>
                              <input
                                type="text"
                                className="form-control"
                                name="bvn"
                                value={bvn}
                                maxLength={11}
                                onChange={(e) => setBvn(e.target.value)}
                                placeholder="Enter your BVN"
                              />
                              <p className="error-message">
                                {bvnResponseMessage}
                              </p>
                            </div>

                            <div className="form-group col-lg-2 col-md-6 col-sm-12 m-b-10">
                              <label>&nbsp;</label>
                              {bvn.length < 11 ? (
                                <button
                                  type="submit"
                                  disabled
                                  className="btn btn-block btn-light font-weight-500"
                                >
                                  {isLoading ? <Loader /> : "Submit BVN"}
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  disabled={isLoading}
                                  className="btn btn-block btn-light font-weight-500"
                                >
                                  {isLoading ? <Loader /> : "Submit BVN"}
                                </button>
                              )}
                            </div>
                          </div>
                        </form>
                      )}

                      {showOtpForm && (
                        <form onSubmit={handleOtpSubmit}>
                          <div className="row m-b-30">
                            <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                              <label>OTP</label>
                              <input
                                type="text"
                                className="form-control"
                                name="otp"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                placeholder="Enter your OTP Number"
                              />
                              {isSubmitted && (
                                <div>
                                  {timer === 0 ? (
                                    <Link
                                      style={{
                                        textDecoration: "underline",
                                        fontWeight: "bold",
                                      }}
                                      className="text-success"
                                      onClick={reSendOtp}
                                    >
                                      Resend OTP
                                    </Link>
                                  ) : (
                                    <div className="text-success">
                                      Resend after: {timer}s
                                    </div>
                                  )}
                                </div>
                              )}

                              <p className="error-message">
                                {otpResponseMessage}
                              </p>
                            </div>

                            <div className="form-group col-lg-2 col-md-6 col-sm-12 m-b-10">
                              <label>&nbsp;</label>
                              <button
                                type="submit"
                                className="btn btn-block btn-outline-success font-weight-500"
                                disabled={isOtpLoading} // Disable button when loading
                              >
                                {isOtpLoading ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm mr-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Verifying...
                                  </>
                                ) : (
                                  "Verify"
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BvnValidation;
